import styled from 'styled-components';

export const GameDetailsContainerDefaultBox = styled.div`
    position: relative;
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
    text-align: center;
    font-size: 1rem;
    align-items: flex-start;

    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 0.85rem;
        justify-content: space-between;
        min-height: 4rem;
    }
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        align-items: center;
        font-size: 0.7rem;
    }
`;
